import axios from 'axios';
import Bugsnag from '@bugsnag/js';
import _ from 'lodash';
import {
  IS_LOADING,
  REPORT_CASE_CONSULT
} from './types';

export const getReportCaseConsult = (docCode, year, month) => async dispatch => {
  const url = `reports/json/referrals/${docCode}?year=${year}&month=${month.toString().padStart(2, '0')}`;

  dispatch({ type: IS_LOADING, status: true, names: { REPORT_CASE_CONSULT: true } });
  await axios.get(url).then(response => {
    dispatch({ type: REPORT_CASE_CONSULT, playload: { cases: response.data } });
    dispatch({ type: IS_LOADING, status: false, names: { REPORT_CASE_CONSULT: false } });
  }).catch(err => {
    let error = err;
    dispatch({ type: IS_LOADING, status: false, names: { REPORT_CASE_CONSULT: false } });
    if ((_.has(error, 'response.status') && error.response.status === 502) || _.isUndefined(error.response)) {
      if (_.isUndefined(error.response)) { error = Error(`502 API at ${url}`); }
      Bugsnag.notify(error);
    }
  });
};
